import {
  transformInventoryInitialDataDatesToMoment,
  transformInventoryDatesToMoment,
} from '../../Dates';
import Connector, { takeQuery } from '../../agent';
import types from './types';
import { push } from 'connected-react-router';
import { changesNotificationModalActions } from '../changesNotificationModal';
import { goToErrorPage } from '../../utils';
import { put, call, takeEvery } from 'redux-saga/effects';
import { createQRStickersPDF } from '../../objects/QRStickerGridPdfCreator';
import { inventoriesActions } from '../../behavior/inventories';

const saveInventoryProcess = data => {
  if (data.inventory) {
    data.inventory.chemicalProduct.selectedChemicalProduct = {
      id: data.inventory.chemicalProduct.id,
      tradeName: data.inventory.chemicalProduct.tradeName,
      chemicalName: data.inventory.chemicalProduct.chemicalName,
    };
    data.inventory = transformInventoryDatesToMoment(data.inventory);
  }
  if (data.recipients) data.recipients.forEach(p => (p.cannotBeDeleted = true));
  return data;
};

export const Inventories = {
  saveInventoryOrOpenConfirmationModal: ({ saveDto }) =>
    Connector.api.post('/inventories', saveDto),
  getInventory: ({ id }) => Connector.api.get(`/inventories/${id}`),
  getDeletedInventory: ({ id }) => Connector.api.get(`/inventories/deleted/${id}`),
  getInventoryTitleDetails: ({ id }) => Connector.api.get(`/inventories/titleDetails/${id}`),
  getInitialData: ({ isCreationMode }) =>
    Connector.api.get(`/inventories/getInitialData`, false, { isCreationMode }),
  deleteInventory: ({ id }) => Connector.api.delete(`/inventories/${id}`),
  isPreciseLocationSet: ({ id }) => Connector.api.get(`/inventories/isPreciseLocationSet/${id}`),
  getNonCheckedChemicals: ({ personId, department, building }) =>
    Connector.api.get(`/inventories/nonChecked`, false, { personId, department, building }),
  markAsChecked: ({ inventoryIds }) => Connector.api.post('/inventories/markChecked', inventoryIds),
  getInventoriesChemicalProductsLabels: ids =>
    Connector.api.get('/inventories/getLabels', false, { ids }),
};

function* createPDF({
  params: {
    gridParameters,
    selectedInventories,
    labelsSupplier,
    labelsSupplierResultMapper,
    urlTemplateFunction,
    downloadFileName,
    errorHandler,
  },
}) {
  try {
    const labelsResult = yield labelsSupplier();
    const labels = labelsSupplierResultMapper(labelsResult);

    createQRStickersPDF(
      gridParameters,
      selectedInventories,
      labels,
      urlTemplateFunction,
      downloadFileName ?? 'qr-stickers.pdf',
      errorHandler
    ).then(yield put(inventoriesActions.createInventoriesQRStickersPdfSuccess()));
  } catch (error) {
    yield put(inventoriesActions.createInventoriesQRStickersPdfFailure(error));
  }
}

const inventorySagas = [
  takeQuery(types.SAVE_INVENTORY_OR_OPEN_CONFIRMATION_MODAL, {
    api: Inventories.saveInventoryOrOpenConfirmationModal,
    process: saveInventoryProcess,
    notify: [
      ({ request, data }) => {
        if (data.inventory === null) {
          //means that there was batch update
          return { type: '' };
        } else {
          return !data.openConfirmationModal
            ? push(`/inventories/view/${data.inventory.id}`)
            : { type: '' };
        }
      },
    ],
    notifyFailure: [() => changesNotificationModalActions.toggle(false)],
  }),
  takeQuery(types.GET_INVENTORY, {
    api: Inventories.getInventory,
    process: transformInventoryDatesToMoment,
    notifyFailure: [goToErrorPage],
  }),
  takeQuery(types.GET_DELETED_INVENTORY, {
    api: Inventories.getDeletedInventory,
    process: transformInventoryDatesToMoment,
    notifyFailure: [goToErrorPage],
  }),
  takeQuery(types.GET_INVENTORY_TITLE_DETAILS, {
    api: Inventories.getInventoryTitleDetails,
    notifyFailure: [goToErrorPage],
  }),
  takeQuery(types.GET_INVENTORY_INITIAL_DATA, {
    api: Inventories.getInitialData,
    process: transformInventoryInitialDataDatesToMoment,
    notifyFailure: [goToErrorPage],
  }),
  takeQuery(types.DELETE_INVENTORY, {
    api: Inventories.deleteInventory,
    notify: [
      ({ request }) =>
        request.params.redirect ? push(`/inventories/overview/entity`) : { type: '' },
    ],
  }),
  takeQuery(types.IS_PRECISE_LOCATION_SET, {
    api: Inventories.isPreciseLocationSet,
  }),
  takeQuery(types.GET_NON_CHECKED_CHEMICALS, {
    api: Inventories.getNonCheckedChemicals,
    notifyFailure: [goToErrorPage],
  }),
  takeQuery(types.MARK_AS_CHECKED, {
    api: Inventories.markAsChecked,
  }),
  takeEvery(types.CREATE_INVENTORIES_QR_STICKERS_PDF, createPDF),
];

export default inventorySagas;
